import { useFormik } from "formik";
import { observer } from 'mobx-react-lite';
import { useEffect } from "react";
import { useSetReminderStore } from "../..";
import { useConditionallyClosable } from "../../hooks/useClosable";
import { ClosableOrder } from "../../store/ClosableStore";
import { DateOption } from "../../store/SetReminderStore";
import commonStyles from '../Common.module.css';
import SelectInput from "../inputs/SelectInput";
import Modal from "../Modal";

function SetReminder() {
    const setReminderStore = useSetReminderStore();

    const formik = useFormik<ISetReminderState>({
        initialValues: SetReminderState.empty(),
        onSubmit: (values) => {
            setReminderStore.setDateWithDateOption(values.dateOption);
        },
    });

    const close = () => setReminderStore.close();
    useConditionallyClosable(ClosableOrder.High, close, setReminderStore.isOpen());

    useEffect(() => {
        if (setReminderStore.isOpen())
            formik.resetForm({ values: SetReminderState.empty() });
    }, [setReminderStore.isOpen()]);

    if (!setReminderStore.isOpen())
        return null;

    return (
        <Modal
            header="Reminder Date?"
            onClose={close}
        >
            <SelectInput formik={formik} label="" name="dateOption" valueAsCorrectType={value => value as DateOption}>
                <option value={DateOption.Week1}>1 Week</option>
                <option value={DateOption.Week2}>2 Week</option>
                <option value={DateOption.Month1}>1 Month</option>
                <option value={DateOption.Day90}>90 Days</option>
                <option value={DateOption.Month6}>6 Months</option>
                <option value={DateOption.Year1}>1 Year</option>
                <option value={DateOption.Year2}>2 Years</option>
                <option value={DateOption.Custom}>Custom</option>
            </SelectInput>
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                <button className={commonStyles.secondaryButton} onClick={close}>Cancel</button>
                <button className={commonStyles.primaryButton} onClick={() => formik.handleSubmit()}>Yes</button>
            </div>
        </Modal>
    );
}

export default observer(SetReminder);

interface ISetReminderState {
    dateOption: DateOption;
}

class SetReminderState implements ISetReminderState {
    dateOption: DateOption = DateOption.Custom;

    static empty() {
        return new SetReminderState();
    }
}